import { h } from 'preact';

const Filter = (props) => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" role="img" {...props}>
			<path d="M11.5 4a1.5 1.5 0 10.001 3.001A1.5 1.5 0 0011.5 4zm0-1a2.5 2.5 0 012.45 2.001L15.5 5a.5.5 0 010 1h-1.55a2.502 2.502 0 01-4.9 0H.5a.5.5 0 010-1l8.55.001A2.5 2.5 0 0111.5 3zm-7 6a1.5 1.5 0 10.001 3.001A1.5 1.5 0 004.5 9zm0-1a2.5 2.5 0 012.45 2.001L15.5 10a.5.5 0 010 1H6.95a2.502 2.502 0 01-4.9 0H.5a.5.5 0 010-1l1.55.001A2.5 2.5 0 014.5 8z" fill-rule="evenodd" clip-rule="evenodd" />
		</svg>
	);
};

export default Filter;
